var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSensor = function SvgSensor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path826",
    fill: "currentColor",
    d: "M14.09.002c-.649-.016-1.579.059-2.703.228C8.668.64 8.36.812 5.998 3.205 3.98 5.25 3.81 5.486 3.868 6.178c.075.914-.493 1.455-1.327 1.263-.46-.105-.717.056-1.547.983C.43 9.054 0 9.748 0 10.027c0 .312.532 1.048 1.453 2.01 1.811 1.892 2.292 1.967 3.61.565.716-.763.894-1.112.894-1.75 0-1.073.49-1.507 1.076-.953.422.398.459.376 2.002-1.225 1.517-1.573 1.56-1.65 1.25-2.143-.203-.323-.263-.696-.166-1.017.225-.74 2.576-3.236 3.871-4.11.615-.414 1.116-.9 1.116-1.08 0-.198-.367-.306-1.016-.322m.252 10.865-3.365 3.15 1.363 1.426C15.252 18.488 16.847 20 17.147 20c.27 0 .925-.523 1.65-1.317.661-.724 1.203-1.444 1.203-1.6 0-.154-1.984-2.363-4.41-4.907z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect4203-5",
    fill: "currentColor",
    d: "M-13.514 13.945h25.152v1.905h-25.152z",
    transform: "scale(1.02893 .9702)rotate(-45)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSensor);
export default ForwardRef;